import { render, staticRenderFns } from "./OrderSuccess.vue?vue&type=template&id=282caca3&scoped=true"
import script from "./OrderSuccess.vue?vue&type=script&lang=js"
export * from "./OrderSuccess.vue?vue&type=script&lang=js"
import style0 from "./OrderSuccess.vue?vue&type=style&index=0&id=282caca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282caca3",
  null
  
)

export default component.exports